import { Flex, MouseLineIcon, Text } from '@modusign/design-system';

interface TutorialButtonProps {
  className?: string;
  variant: 'basic' | 'dark';
  onClick?: () => void;
}

const defaultProps = {
  variant: 'basic',
};

function TutorialButton({ className, variant, onClick }: TutorialButtonProps) {
  return (
    <Flex
      as="button"
      className={className}
      p={2}
      sx={{
        color: variant === 'basic' ? 'textNeutralLight' : 'textNeutralUltraLight',
        '&:hover': {
          color: variant === 'basic' ? 'textNeutralBase' : 'textNeutralLightest',
        },
      }}
      onClick={onClick}
    >
      <MouseLineIcon />
      <Text fontWeight="medium">튜토리얼</Text>
    </Flex>
  );
}

TutorialButton.defaultProps = defaultProps;

export default TutorialButton;
